export const isChecked = (elem: HTMLElement | null) => {
  return (
    elem &&
    elem instanceof HTMLInputElement &&
    elem.type === 'checkbox' &&
    elem.checked
  );
};

export const isSelected = (elem: HTMLElement | null, value: string) => {
  return (
    elem &&
    (elem instanceof HTMLInputElement || elem instanceof HTMLInputElement) &&
    elem.value === value
  );
};
